import { Component } from '@angular/core';
import { IWrappableComponent } from '../../types/IWrappableComponent';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';

// Abstract which can be extended to attach wrappable feature
@Component({
	selector: 'ws-wrapper',
	template: ``,
})
export abstract class WrappableComponent implements IWrappableComponent {
	protected wrapperRef?: DialogWrapperComponent;

	constructor() {}

	// Method called by wrapper to establish reference
	setWrapperRef(wrapper: DialogWrapperComponent): void {
		this.wrapperRef = wrapper;
	}

	// Example method that triggers recreation
	refreshComponent(): void {
		if (this.wrapperRef) {
			this.wrapperRef.recreateComponent();
		}
	}
}
